export const REQUIRED_PASSWORD_LENGTH = 8
export const GRID_SIZE_MD = 828
export const GRID_SIZE_LG = 1180
export const GRID_SIZE_XL = 1480
export const GRID_SIZE_DEFAULT = 1200
